import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Menu } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { states, updateStates } from '@/constants/lifecycle';
import WarningPopup from '@/components/WarningPopup';
import { toggleUserApproved } from '../actions';

const UserApproveAction = ({
  approve,
  approved,
  category,
  code,
  disabled,
  fullscreen,
  hasLabels,
  isCurrentUser,
}) => {
  const intl = useIntl();
  return (
    <WarningPopup disabled={!isCurrentUser} position="right center">
      <Menu.Item
        name={approved ? 'unapprove' : 'approve'}
        title={intl.formatMessage({ id: approved ? 'status.unapprove.hover' : 'status.approve.hover' })}
        onClick={disabled ? undefined : () => approve(category, code)}
        className="aridhia-user-approve-action aridhia-ribbon-menu"
        disabled={disabled}
        rel="noopener noreferrer"
      >
        {!fullscreen && (<Icon name={approved ? 'thumbs down' : 'thumbs up'} />)}
        {hasLabels && (<FormattedMessage id={approved ? 'actions.unapprove' : 'actions.approve'} />)}
      </Menu.Item>
    </WarningPopup>
  );
};

const mapStateToProps = ({
  auth: { users, currentUser },
  layout: { labels, fullscreen },
}, { category, code }) => {
  const item = findResult(users, category, code) || { ...updateStates, approved: false };

  return ({
    approved: item.approved,
    disabled: item.updateStatus === states.PENDING,
    fullscreen,
    hasLabels: labels || fullscreen,
    isCurrentUser: code === currentUser.id,
  });
};

const mapDispatchToProps = {
  approve: toggleUserApproved,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserApproveAction);
